export default {"src":"/_next/static/media/deco_paypal_light.82f8962e.svg","height":60,"width":100,"blurWidth":0,"blurHeight":0};